import { useEffect, useState } from 'react';
import './index.css';
import { getUploadBenefits, initAudioImport } from '@/bussiness/AudioImportHandler';
import AudioImportDialog from './AudioImportDialog';
import IC_IMPORT_AUDIO from '@/assets/import/ic_import.svg?react';
import { IS_PRIVATE } from '@/config';
import { message } from 'antd';

export default function AudioImport() {
  const [showImportDialog, setShowImportDialog] = useState(false);

  const handleOpen = async () => {
    console.log("====", import.meta.env.MODE);
    const canOpen = await getUploadBenefits(true);
    if (!canOpen) {
      message.error('检查上传收益失败，请稍后重试');
      return;
    }
    setShowImportDialog(true);
  };

  useEffect(() => {
    initAudioImport();
  }, []);

  const handleClose = () => {
    setShowImportDialog(false);
  };

  return (
    <>
      {!IS_PRIVATE && (
        <div
          className="flex flex-items-center flex-justify-center h-9.5 px-3.5 border-solid border-1 border-#383B50/30 rd-2.5 cursor-pointer"
          onClick={handleOpen}
        >
          <IC_IMPORT_AUDIO className="w-4.5 h-4.5" />
          <span className="text-mx-secondary text-size-3.5 ml-1">导入文件</span>
        </div>
      )}
      {showImportDialog && (
        <AudioImportDialog onClose={handleClose} />
      )}
    </>
  );
}
